export default () => {
  let readyResolve;
  const onReady = new Promise((resolve) => {
    readyResolve = resolve;
  });

  return {
    account: {},
    accountPromise: null,
    accounts: [],
    billingErrors: {},
    coupon: null,
    couponLoading: false,
    currentUser: {},
    currentUserPromise: null,
    onReady,
    partner: {},
    partnerPromise: null,
    permissions: {},
    permissionsPromise: null,
    profile: {},
    profilePromise: null,
    readyResolve,
  };
};
